import OrderReportPage from "./OrderReportPage";

export {OrderReportPage}
export default OrderReportPage
